import './checkbox.css';

import { CheckIcon, MinusIcon } from '@heroicons/react/24/outline';
import { Indicator, Root } from '@radix-ui/react-checkbox';
import React from 'react';

import { cn } from '@/services/utils';

type CheckboxProps = Omit<React.ComponentPropsWithoutRef<typeof Root>, 'checked'> & {
    isChecked: boolean;
    isIndeterminate?: boolean;
};

const Checkbox = React.forwardRef<
    React.ElementRef<typeof Root>,
    CheckboxProps
>(({ className, isChecked, isIndeterminate, ...props }, ref) => (
    <Root
        ref={ref}
        checked={isIndeterminate ? 'indeterminate' : isChecked}
        className={cn(
            `scoped-checkbox
             tw-border
             tw-p-0
             tw-border-solid
             tw-bg-white
             tw-peer
             tw-h-4
             tw-w-4
             tw-shrink-0
             tw-rounded-md
             tw-cursor-pointer
             disabled:cursor-not-allowed
             data-[disabled]:tw-border-primary
             data-[disabled]:tw-bg-fill-secondary`,
            className
        )}
        {...props}>
        <Indicator
            className={cn('tw-flex tw-items-center tw-justify-center tw-text-current')}>
            {isIndeterminate
                ? <MinusIcon className="scoped-checkbox-mark tw-stroke-2 tw-block" />
                : <CheckIcon className="scoped-checkbox-mark tw-stroke-2 tw-block" />}
        </Indicator>
    </Root>
));

Checkbox.displayName = Root.displayName;

export { Checkbox };
export type { CheckboxProps };
